const HERO_FLIGHT = 'hero-flight.svg';

export const URL_HERO_FOLDER = 'web/travel/heros';

export const IMAGE_TYPE = {
  HOTEL: 'HOTEL',
  FLIGHT: 'FLIGHT',
  BUS: 'BUS',
  AUTO: 'AUTO',
  EXTRA: 'EXTRA'
};

export const IMAGE_HERO_URL = {
  HOTEL: 'hero-hotel.svg',
  FLIGHT: HERO_FLIGHT,
  BUS: HERO_FLIGHT,
  AUTO: 'hero-car.svg',
  EXTRA: 'hero-extra.png',
};

export const VAR_BORDER_RADIUS = 'border-radius';
